/* eslint-disable complexity */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { getImageFilePath, isClient } from '@tcp/core/src/utils';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import CarouselSkeleton from '@tcp/core/src/components/features/browse/CategoryListingPage/molecules/CarouselSkeleton';
import withStyles from '../../../hoc/withStyles';
import styles, { StyledDiv, StyledDivV2 } from '../styles/OutfitCarouselModule.style';
import { StyledDivV3 } from '../styles/OutfitCarouselModuleV3.style';
import {
  getIconPath,
  styleOverrideEngine,
  getViewportInfo,
  configureInternalNavigationFromCMSUrl,
  parseBoolean,
  getModuleModClassSpacing,
} from '../../../../../utils';
import theme from '../../../../../../styles/themes/TCP';
import Carousel from '../../Carousel';
import SafeComponent from '../../../hoc/withErrorBoundary';
import OutfitCarouselPillVariation from '../molecules/OutfitCarouselPillVariation';
import { StyledDivV4 } from '../styles/OutfitCarouselModuleV4.style';
import StyledDivV5 from '../styles/OutfitCarouselModuleV5.style';

const { breakpoints } = theme;

const CAROUSEL_OPTIONS = {
  autoplay: false,
  arrows: true,
  centerMode: false,
  fade: false,
  speed: 300,
  lazyLoad: false,
  dots: false,
  swipe: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: isClient(),
  responsive: [
    {
      breakpoint: parseInt(breakpoints.medium, 10) - 1,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
        arrows: false,
        swipeToSlide: true,
        lazyLoad: false,
      },
    },
    {
      breakpoint: parseInt(breakpoints.large, 10) - 1,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
  ],
};

const getCarouselConfigV2 = (variation3, sbcDesignVariationCircle) => {
  return {
    autoplay: false,
    arrows: true,
    centerMode: false,
    fade: false,
    speed: 300,
    lazyLoad: false,
    dots: false,
    swipe: true,
    slidesToShow: variation3 && sbcDesignVariationCircle ? 5 : 6, // change based on abtest , this is for Design 2
    slidesToScroll: 1,
    infinite: isClient(),
    responsive: [
      {
        breakpoint: parseInt(breakpoints.medium, 10) - 1,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          arrows: false,
          swipeToSlide: true,
          lazyLoad: false,
        },
      },
      {
        breakpoint: parseInt(breakpoints.largeMax, 10) - 1,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: '1700px',
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
        },
      },
    ],
  };
};

const getCarouselConfigV3 = (mediaLinkedListLength) => {
  return {
    autoplay: false,
    arrows: true,
    centerMode: false,
    fade: false,
    speed: 300,
    lazyLoad: false,
    dots: false,
    swipe: true,
    slidesToShow: 8,
    slidesToScroll: 1,
    infinite: isClient(),

    responsive: [
      {
        breakpoint: parseInt(breakpoints.medium, 10) - 1,
        settings: {
          slidesToShow: mediaLinkedListLength >= 2.5 ? 2.5 : mediaLinkedListLength,
          slidesToScroll: 1,
          arrows: false,
          swipeToSlide: true,
          lazyLoad: false,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: mediaLinkedListLength >= 5 ? 5 : mediaLinkedListLength,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: mediaLinkedListLength >= 6 ? 6 : mediaLinkedListLength,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 1650,
        settings: {
          slidesToShow: mediaLinkedListLength >= 7 ? 7 : mediaLinkedListLength,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: mediaLinkedListLength >= 8 ? 8 : mediaLinkedListLength,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 2100,
        settings: {
          slidesToShow: mediaLinkedListLength >= 9 ? 9 : mediaLinkedListLength,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 2300,
        settings: {
          slidesToShow: mediaLinkedListLength >= 10 ? 10 : mediaLinkedListLength,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 2600,
        settings: {
          slidesToShow: mediaLinkedListLength >= 12 ? 12 : mediaLinkedListLength,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 2800,
        settings: {
          slidesToShow: mediaLinkedListLength >= 13 ? 13 : mediaLinkedListLength,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
        },
      },
    ],
  };
};

const configMapV4HiddenLeftNav = {
  1200: 7,
  1250: 7,
  1350: 8,
  1499: 9,
  1650: 10,
  1900: 12,
  2100: 12,
  2300: 13,
  2600: 15,
  2800: 16,
  9999: 17,
};

const configMapV4Default = {
  1499: 7,
  1650: 7,
  1900: 9,
  2100: 11,
  2300: 11,
  2600: 14,
  2800: 14,
  9999: 15,
};

const getCarouselConfigV4HiddenLeftNav = (mediaLinkedListLength) => {
  return [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow:
          mediaLinkedListLength >= configMapV4HiddenLeftNav[1200]
            ? configMapV4HiddenLeftNav[1200]
            : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
      infinite: mediaLinkedListLength > configMapV4HiddenLeftNav[1200],
    },
    {
      breakpoint: 1250,
      settings: {
        slidesToShow:
          mediaLinkedListLength >= configMapV4HiddenLeftNav[1250]
            ? configMapV4HiddenLeftNav[1250]
            : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
      infinite: mediaLinkedListLength > configMapV4HiddenLeftNav[1250],
    },
    {
      breakpoint: 1350,
      settings: {
        slidesToShow:
          mediaLinkedListLength >= configMapV4HiddenLeftNav[1350]
            ? configMapV4HiddenLeftNav[1350]
            : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
      infinite: mediaLinkedListLength > configMapV4HiddenLeftNav[1350],
    },
    {
      breakpoint: 1499,
      settings: {
        slidesToShow:
          mediaLinkedListLength > configMapV4HiddenLeftNav[1499]
            ? configMapV4HiddenLeftNav[1499]
            : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength > configMapV4HiddenLeftNav[1499],
      },
    },
    {
      breakpoint: 1650,
      settings: {
        slidesToShow:
          mediaLinkedListLength >= configMapV4HiddenLeftNav[1650]
            ? configMapV4HiddenLeftNav[1650]
            : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength > configMapV4HiddenLeftNav[1650],
      },
    },
    {
      breakpoint: 1900,
      settings: {
        slidesToShow:
          mediaLinkedListLength >= configMapV4HiddenLeftNav[1900]
            ? configMapV4HiddenLeftNav[1900]
            : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength > configMapV4HiddenLeftNav[1900],
      },
    },
    {
      breakpoint: 2100,
      settings: {
        slidesToShow:
          mediaLinkedListLength >= configMapV4HiddenLeftNav[2100]
            ? configMapV4HiddenLeftNav[2100]
            : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength > configMapV4HiddenLeftNav[2100],
      },
    },
    {
      breakpoint: 2300,
      settings: {
        slidesToShow:
          mediaLinkedListLength >= configMapV4HiddenLeftNav[2300]
            ? configMapV4HiddenLeftNav[2300]
            : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength > configMapV4HiddenLeftNav[2300],
      },
    },
    {
      breakpoint: 2600,
      settings: {
        slidesToShow:
          mediaLinkedListLength >= configMapV4HiddenLeftNav[2600]
            ? configMapV4HiddenLeftNav[2600]
            : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength > configMapV4HiddenLeftNav[2600],
      },
    },
    {
      breakpoint: 2800,
      settings: {
        slidesToShow:
          mediaLinkedListLength >= configMapV4HiddenLeftNav[2800]
            ? configMapV4HiddenLeftNav[2800]
            : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength > configMapV4HiddenLeftNav[2800],
      },
    },
    {
      breakpoint: 9999,
      settings: {
        slidesToShow:
          mediaLinkedListLength >= configMapV4HiddenLeftNav[9999]
            ? configMapV4HiddenLeftNav[9999]
            : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength > configMapV4HiddenLeftNav[9999],
      },
    },
  ];
};

const getDefaultResponsiveCarouselConfigV4 = (mediaLinkedListLength) => {
  return [
    {
      breakpoint: parseInt(breakpoints.medium, 10) - 1,
      settings: {
        slidesToShow: mediaLinkedListLength >= 2.5 ? 2.5 : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: false,
        swipeToSlide: true,
        lazyLoad: false,
      },
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: mediaLinkedListLength >= 5 ? 5 : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 1350,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 1499,
      settings: {
        slidesToShow: mediaLinkedListLength > 7 ? 8 : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength >= 8,
      },
    },
    {
      breakpoint: 1650,
      settings: {
        slidesToShow: mediaLinkedListLength >= 7 ? 8 : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength >= 8,
      },
    },
    {
      breakpoint: 1900,
      settings: {
        slidesToShow: mediaLinkedListLength >= 9 ? 10 : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength >= 10,
      },
    },
    {
      breakpoint: 2100,
      settings: {
        slidesToShow: mediaLinkedListLength >= 11 ? 12 : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength >= 12,
      },
    },
    {
      breakpoint: 2300,
      settings: {
        slidesToShow: mediaLinkedListLength >= 15 ? 12 : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength >= 12,
      },
    },
    {
      breakpoint: 2600,
      settings: {
        slidesToShow: mediaLinkedListLength >= 15 ? 12 : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength >= 15,
      },
    },
    {
      breakpoint: 2800,
      settings: {
        slidesToShow: mediaLinkedListLength >= 15 ? 15 : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength >= 15,
      },
    },
    {
      breakpoint: 9999,
      settings: {
        slidesToShow: mediaLinkedListLength >= 15 ? 16 : mediaLinkedListLength,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        infinite: mediaLinkedListLength >= 16,
      },
    },
  ];
};

const getCarouselConfigV4 = (mediaLinkedListLength, shouldHideLeftNavigation) => {
  return {
    autoplay: false,
    arrows: true,
    centerMode: false,
    fade: false,
    speed: 300,
    lazyLoad: false,
    dots: false,
    swipe: true,
    slidesToShow: 8,
    slidesToScroll: 1,
    infinite: isClient(),

    responsive: shouldHideLeftNavigation
      ? getCarouselConfigV4HiddenLeftNav(mediaLinkedListLength)
      : getDefaultResponsiveCarouselConfigV4(mediaLinkedListLength),
  };
};

const isContentPage = () => {
  if (typeof window !== 'undefined' && window.location) {
    return window.location.pathname.includes('/content/');
  }
  return false;
};

const fetchStringFromAsPathRegex = /^(?:\/c\/)?(.*?)(?:\?|$)/;

const getActiveCategoryVal = (target, action, url, currentPathName) => {
  const matchedStringVal = target === '_modal' && !isEmpty(action) ? action : url;
  const fetchedVal = matchedStringVal.match(fetchStringFromAsPathRegex);
  const fetchCurrentPathName = currentPathName.match(fetchStringFromAsPathRegex);

  return fetchedVal[1] === fetchCurrentPathName[1];
};

export class OutfitCarouselModule extends PureComponent {
  static propTypes = {
    data: PropTypes.shape({}),
    className: PropTypes.string,
    moduleClassName: PropTypes.string,
    headLine: PropTypes.shape(
      PropTypes.arrayOf(
        PropTypes.oneOfType(
          PropTypes.shape({
            text: PropTypes.string,
          })
        )
      )
    ).isRequired,
    subHeadLine: PropTypes.shape(
      PropTypes.arrayOf(
        PropTypes.oneOfType(
          PropTypes.shape({
            text: PropTypes.string,
          })
        )
      )
    ).isRequired,
    mediaLinkedList: PropTypes.shape(
      PropTypes.arrayOf(
        PropTypes.oneOfType(
          PropTypes.shape({
            image: PropTypes.shape({}),
            link: PropTypes.shape({}),
          })
        )
      )
    ).isRequired,
    isHomePage: PropTypes.bool.isRequired,
    viaModule: PropTypes.string,
    currentListingName: PropTypes.string.isRequired,
    isPromoForMobile: PropTypes.bool,
    currentPathName: PropTypes.string,
  };

  static defaultProps = {
    data: {},
    className: '',
    moduleClassName: '',
    viaModule: '',
    isPromoForMobile: false,
    currentPathName: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      isSsrDone: false,
      isMounted: false,
    };
  }

  static contextType = LabelsContext;

  componentDidMount() {
    const { isMobile } = isClient() ? getViewportInfo() : { isMobile: false };
    if (isMobile) {
      const element = document.querySelector('.active-category');
      if (element) {
        this.scrollTo(element);
      }
    }

    this.setState({
      isSsrDone: true,
      isMounted: true,
    });
  }

  scrollTo = (el) => {
    const elLeft = el?.offsetLeft + el?.offsetWidth;
    const elParentLeft = el?.parentNode.offsetLeft + el?.parentNode.offsetWidth;
    const elOffsetWidth = el?.offsetWidth;

    // check if element not in view
    if (elLeft >= elParentLeft + el?.parentNode.scrollLeft) {
      // eslint-disable-next-line no-param-reassign
      el.parentNode.scrollLeft = elLeft - elParentLeft + elOffsetWidth;
    } else if (elLeft <= el?.parentNode.offsetLeft + el?.parentNode.scrollLeft) {
      // eslint-disable-next-line no-param-reassign
      el.parentNode.scrollLeft = el.offsetLeft - el.parentNode.offsetLeft + elOffsetWidth;
    }
  };

  renderLinkText = (text, variation2, variation3) => {
    return text ? `${text}${variation2 || variation3 ? '' : ' >'}` : '';
  };

  renderItems = (
    mediaLinkedList,
    className,
    viaModule,
    itemClassName = '',
    selectedSlideIndex,
    styleOverrides,
    isDamImageV2Enabled,
    sbcDesignVariationRectangle,
    sbcDesignVariationCircle,
    moduleAnalyticsTag
    // eslint-disable-next-line sonarjs/cognitive-complexity
  ) => {
    const itemProps = itemClassName ? { className: itemClassName } : {};
    const { variation2 = false, variation3 = false } = styleOverrides || {};
    return (
      mediaLinkedList &&
      mediaLinkedList.map(({ image, link }, index) => {
        const internalPath = configureInternalNavigationFromCMSUrl(link.url);
        const toPath = `${internalPath}&viaModule=${viaModule}&viaPage=CLP`;
        const asPath = link.url;
        const preloadImage = index <= 5;
        const anchorProps = { useRouterNavigation: true, updateRoute: true };
        return (
          <div
            key={`${itemClassName}${index.toString()}`}
            {...itemProps}
            className={`${variation2 || variation3 ? 'tile-container' : ''} ${
              selectedSlideIndex === index ? 'active-category' : ''
            }`}
          >
            {variation2 || (variation3 && sbcDesignVariationCircle) ? (
              <div className="image-circle">
                <Anchor
                  className="image-link"
                  to={toPath}
                  asPath={asPath}
                  dataLocator="dummy-datalocator"
                  moduleAnalyticsTag={moduleAnalyticsTag}
                  {...anchorProps}
                >
                  {image && (
                    <DamImage
                      className={`${className} carousel-image`}
                      imgData={{
                        alt: image?.title,
                        url: image?.url,
                      }}
                      imgConfigs={[`w_310`, `w_300`, `w_300`]}
                      loadAuto
                      preloadImage={preloadImage}
                      lazyLoadImage={!preloadImage}
                      isHomePage
                      isDamImageV2Enabled={isDamImageV2Enabled}
                      moduleAnalyticsTag={moduleAnalyticsTag}
                    />
                  )}
                </Anchor>
              </div>
            ) : (
              <div
                className={`aspect-ratio-box ${
                  selectedSlideIndex === index ? 'active-category' : ''
                }`}
              >
                <Anchor
                  className="image-link"
                  to={toPath}
                  asPath={asPath}
                  dataLocator="dummy-datalocator"
                  moduleAnalyticsTag={moduleAnalyticsTag}
                  {...anchorProps}
                >
                  {image && (
                    <DamImage
                      className={`${className} carousel-image aspect-ratio-box-inside`}
                      imgData={{
                        alt: image?.title,
                        url: image?.url,
                      }}
                      imgConfigs={[`w_310`, `w_300`, `w_300`]}
                      loadAuto
                      preloadImage={preloadImage}
                      lazyLoadImage={!preloadImage}
                      isHomePage
                      isDamImageV2Enabled={isDamImageV2Enabled}
                      moduleAnalyticsTag={moduleAnalyticsTag}
                    />
                  )}
                </Anchor>
              </div>
            )}
            <Anchor
              className="image-link"
              to={toPath}
              asPath={asPath}
              fontSizeVariation="small"
              dataLocator="dummy-datalocator"
              moduleAnalyticsTag={moduleAnalyticsTag}
              {...anchorProps}
            >
              <BodyCopy
                component="pre"
                fontFamily="secondary"
                fontSize={variation2 ? ['fs16', 'f16', 'fs16'] : 'fs14'}
                fontWeight={variation2 ? 'medium' : 'normal'}
                lineHeight="14px"
                textAlign="center"
              >
                {this.renderLinkText(link?.text, variation2, variation3)}
              </BodyCopy>
            </Anchor>
          </div>
        );
      })
    );
  };

  getCarouselKey = () => {
    const { isSsrDone } = this.state;

    return isSsrDone ? 'client' : 'server';
  };

  getPrevArrow = () => {
    return (
      <button className="prevArrow">
        <Image
          className="prevArr"
          src={`${getImageFilePath()}/icon_forward.svg`}
          alt="previous"
          height="40px"
        />
      </button>
    );
  };

  getNextArrow = () => {
    return (
      <button className="nextArrow">
        <Image
          className="nextArr"
          src={`${getImageFilePath()}/icon_forward.svg`}
          alt="previous"
          height="40px"
        />
      </button>
    );
  };

  renderOutfitCarousel = ({
    mediaLinkedList,
    className,
    viaModule,
    styleOverrides,
    variation2 = false,
    variation3 = false,
    isPromoForMobile,
    isDamImageV2Enabled,
    sbcDesignVariationRectangle,
    sbcDesignVariationCircle,
    moduleAnalyticsTag,
    currentPathName,
  }) => {
    const { shouldHideLeftNavigation, isMountedHideLeftNavigationOnPLPEnabled } = this.props;
    const { isMobile } = isClient() ? getViewportInfo() : {};
    const carouselSlidesOverride =
      (!isEmpty(styleOverrides) && styleOverrides['carousel-slides']) || {};
    const applyOverride = carouselSlidesOverride?.slidesToShow <= mediaLinkedList?.length;
    let carouselOptionsConfig = CAROUSEL_OPTIONS;
    let carouselConfig = {
      autoplay: false,
      customArrowLeft: getIconPath('family-outfit-arrow'),
      customArrowRight: getIconPath('family-outfit-arrow'),
    };
    if (variation2 && mediaLinkedList?.length) {
      carouselOptionsConfig = getCarouselConfigV2();
    }
    if (variation3 && mediaLinkedList?.length) {
      carouselOptionsConfig = getCarouselConfigV3(mediaLinkedList.length);
    }
    if (variation3 && sbcDesignVariationRectangle) {
      carouselOptionsConfig = getCarouselConfigV4(mediaLinkedList.length, shouldHideLeftNavigation);
    }

    if (variation3 && sbcDesignVariationCircle) {
      carouselOptionsConfig = getCarouselConfigV2(variation3, sbcDesignVariationCircle);
      const ctaOptions = {
        prevArrow: this.getPrevArrow(),
        nextArrow: this.getNextArrow(),
      };
      carouselOptionsConfig = { ...carouselOptionsConfig, ...ctaOptions };
      carouselConfig = { autoplay: false };
    }
    const carouselOptions = applyOverride
      ? { ...carouselOptionsConfig, ...carouselSlidesOverride }
      : { ...carouselOptionsConfig };
    let selectedSlideIndex = 0;
    for (let i = 0; i < mediaLinkedList?.length; i += 1) {
      const { link } = mediaLinkedList[i];
      const { target, action, url } = link;
      const activeIndex = getActiveCategoryVal(target, action, url, currentPathName);
      if (activeIndex) {
        selectedSlideIndex = i;
        break;
      }
    }

    return isMobile || isPromoForMobile ? (
      <div>
        <div className="container-carousel">
          {this.renderItems(
            mediaLinkedList,
            className,
            '',
            'carousel-inner-container',
            selectedSlideIndex,
            styleOverrides,
            isDamImageV2Enabled,
            sbcDesignVariationRectangle,
            sbcDesignVariationCircle,
            moduleAnalyticsTag
          )}
        </div>
      </div>
    ) : (
      <div className={`${!isEmpty(carouselSlidesOverride) ? 'container-carousel-desktop' : ''}`}>
        <Carousel
          key={this.getCarouselKey()}
          options={{
            ...carouselOptions,
          }}
          carouselConfig={{ ...carouselConfig }}
          selectedSlideIndex={selectedSlideIndex}
          fromOutfitCarouselModule
          isMountedHideLeftNavigationOnPLPEnabled={isMountedHideLeftNavigationOnPLPEnabled}
        >
          {this.renderItems(
            mediaLinkedList,
            className,
            viaModule,
            '',
            selectedSlideIndex,
            styleOverrides,
            isDamImageV2Enabled,
            sbcDesignVariationRectangle,
            sbcDesignVariationCircle,
            moduleAnalyticsTag
          )}
        </Carousel>
      </div>
    );
  };

  getExtraConfig = (extraConfig) => extraConfig || {};

  getStyledOverrides = (styleOverrides) => styleOverrides || {};

  getTextValue = (arr) => arr && arr[0].text;

  renderOldVariation = ({
    styleOverrides,
    className,
    headerLineText,
    subHeaderLineText,
    mediaLinkedList,
    viaModule,
    currentListingName,
    isPromoForMobile,
    isDamImageV2Enabled,
    sbcDesignVariationRectangle,
    sbcDesignVariationCircle,
    moduleAnalyticsTag,
    currentPathName,
  }) => {
    const { shouldHideLeftNavigation, isMountedHideLeftNavigationOnPLPEnabled } = this.props;
    const {
      variation2 = false,
      variation3 = false,
      title = '',
      subTitle = '',
    } = this.getStyledOverrides(styleOverrides);
    const { marginTop = {}, marginBottom = {} } = getModuleModClassSpacing(styleOverrides);
    let StyledContainer = StyledDiv;
    let styleClass = '';
    if (variation2) {
      StyledContainer = StyledDivV2;
      styleClass = 'V2';
    }
    if (variation3) {
      if (sbcDesignVariationRectangle) {
        if (sbcDesignVariationCircle) {
          StyledContainer = StyledDivV5;
          styleClass = 'V5';
        } else {
          StyledContainer = StyledDivV4;
          styleClass = 'V4';
        }
      } else {
        StyledContainer = StyledDivV3;
        styleClass = 'V3';
      }
    }
    return (
      <StyledContainer
        className={`${className} ${styleClass ? `content-outfit${styleClass}` : 'content-outfit'}`}
        variation2={variation2}
        variation3={variation3}
        sbcDesignVariationCircle={sbcDesignVariationCircle}
        spacingTop={marginTop}
        spacingBottom={marginBottom}
        shouldHideLeftNavigation={shouldHideLeftNavigation}
        mediaLinkedListLength={mediaLinkedList?.length}
        configMapV4HiddenLeftNav={configMapV4HiddenLeftNav}
        configMapV4Default={configMapV4Default}
        isMountedHideLeftNavigationOnPLPEnabled={isMountedHideLeftNavigationOnPLPEnabled}
      >
        {!variation3 && (
          <BodyCopy
            style={title || {}}
            fontSize={['fs16', 'fs16', 'fs28']}
            fontWeight="black"
            className="heading"
          >
            {headerLineText}
          </BodyCopy>
        )}
        <BodyCopy
          fontFamily="secondary"
          style={subTitle || {}}
          fontSize={
            variation2 || sbcDesignVariationCircle
              ? ['fs20', 'f20', 'fs22']
              : ['fs15', 'fs15', 'fs22']
          }
          fontWeight={variation2 || sbcDesignVariationCircle ? 'bold' : 'regular'}
          className="subheading"
        >
          {subHeaderLineText}
        </BodyCopy>
        {this.renderOutfitCarousel({
          mediaLinkedList,
          className,
          viaModule,
          styleOverrides,
          currentListingName,
          variation2,
          variation3,
          isPromoForMobile,
          isDamImageV2Enabled,
          sbcDesignVariationRectangle,
          sbcDesignVariationCircle,
          moduleAnalyticsTag,
          currentPathName,
        })}
      </StyledContainer>
    );
  };

  render() {
    const { isMounted } = this.state;
    if (!isMounted) {
      return <CarouselSkeleton />;
    }

    const { extraConfig } = this.context;
    const {
      isDamImageV2Enabled,
      outfitCarouselPillCategories,
      outfitPillWidthValue,
      outfitPillHeightValue,
      outfitPillColorValue,
      outfitPillBGColorValue,
      outfitPillFontSizeValue,
      isGlobalOutfitHeaderSectionVisibleWeb,
      currentNavId,
      isOutfitCarouselPillDesignEnabled,
      outfitCarouselPillCategoriesAB,
    } = this.getExtraConfig(extraConfig);
    const {
      data,
      className,
      moduleClassName,
      viaModule,
      currentListingName,
      isPromoForMobile,
      isHomePage,
      currentPathName,
      sbcDesignVariationRectangle,
      sbcDesignVariationCircle,
      moduleAnalyticsTag,
      moduleEnablePillView,
      isOutfitPillVariationEnabledOnAllPlps,
    } = this.props;
    let { headLine, subHeadLine, mediaLinkedList } = this.props;
    if (data) {
      const { headLine: hl, subHeadLine: sl, mediaLinkedList: ml } = this.props;
      headLine = hl;
      subHeadLine = sl;
      mediaLinkedList = ml;
    }
    const headerLineText = this.getTextValue(headLine);
    const subHeaderLineText = this.getTextValue(subHeadLine);
    const styleOverrides = styleOverrideEngine(moduleClassName, 'OutfitCarousel');
    const isPillViewEnabled = parseBoolean(moduleEnablePillView) && (isHomePage || isContentPage());
    const pillCategoriesArray = outfitCarouselPillCategories?.split(',');
    const pillCategoriesABVal = outfitCarouselPillCategoriesAB?.split(',');
    const isPillVariation =
      Array.isArray(pillCategoriesArray) &&
      pillCategoriesArray.length > 0 &&
      pillCategoriesArray.some((element) => {
        return element?.trim()?.toString() === currentNavId?.trim()?.toString();
      });
    const isPillVariationAB =
      isOutfitCarouselPillDesignEnabled &&
      Array.isArray(pillCategoriesABVal) &&
      pillCategoriesABVal.length > 0 &&
      pillCategoriesABVal.some((element) => {
        return element?.trim()?.toString() === currentNavId?.trim()?.toString();
      });
    const isPillEnabled =
      isPillVariation ||
      isPillVariationAB ||
      isPillViewEnabled ||
      isOutfitPillVariationEnabledOnAllPlps;
    const customColor = !isEmpty(outfitPillColorValue) ? outfitPillColorValue : '#FFF';
    const customBGColor = !isEmpty(outfitPillBGColorValue) ? outfitPillBGColorValue : '#112f69';
    const customFontSize = !isEmpty(outfitPillFontSizeValue)
      ? parseInt(outfitPillFontSizeValue, 10)
      : 13;

    return (
      <>
        {isPillEnabled ? (
          <OutfitCarouselPillVariation
            header={headerLineText}
            subHeader={subHeaderLineText}
            styleOverrides={styleOverrides}
            linkedListData={mediaLinkedList}
            customWidth={outfitPillWidthValue}
            customHeight={outfitPillHeightValue}
            customColor={customColor}
            customBGColor={customBGColor}
            customWFontSize={customFontSize}
            hideHeaderBar={isGlobalOutfitHeaderSectionVisibleWeb}
            windowSize={[window?.innerWidth]}
            currentPathName={currentPathName}
          />
        ) : (
          this.renderOldVariation({
            styleOverrides,
            className,
            headerLineText,
            subHeaderLineText,
            mediaLinkedList,
            viaModule,
            currentListingName,
            isPromoForMobile,
            isDamImageV2Enabled,
            sbcDesignVariationRectangle,
            sbcDesignVariationCircle,
            moduleAnalyticsTag,
            currentPathName,
          })
        )}
      </>
    );
  }
}

OutfitCarouselModule.displayName = 'OutfitCarouselModule';
export { OutfitCarouselModule as OutfitCarouselModuleVanilla };
export default withStyles(SafeComponent(OutfitCarouselModule), styles);
